import { useOffline } from '../context/OfflineContext';
import './OfflineBanner.css';

export default function OfflineBanner() {
  const { isOnline, pendingCount, syncing } = useOffline();

  if (isOnline && pendingCount === 0) return null;

  return (
    <div className={`offline-banner ${!isOnline ? 'offline' : 'syncing'}`}>
      {!isOnline ? (
        <>
          <i className="ti ti-wifi-off"></i>
          <span>Offline mód – bejegyzések helyileg mentve</span>
          {pendingCount > 0 && (
            <span className="pending-badge">{pendingCount} függőben</span>
          )}
        </>
      ) : (
        <>
          <i className={`ti ${syncing ? 'ti-refresh' : 'ti-cloud-upload'}`}></i>
          <span>{syncing ? 'Szinkronizálás...' : `${pendingCount} bejegyzés szinkronizálásra vár`}</span>
        </>
      )}
    </div>
  );
}